"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var enums_1 = require("./enums");
var init = /** @class */ (function () {
    function init(_a) {
        var _this = this;
        var props = __rest(_a, []);
        this.props = props;
        this.props.environment = this.props.environment
            ? this.props.environment
            : enums_1.Environment.development;
        this.loadDependencies().then(function () {
            _this.props.onCoreLoaded && _this.props.onCoreLoaded();
            if (_this.props.aotLoading) {
                _this.loadComponents();
            }
        });
    }
    init.prototype.dispatchWindowEvents = function (EventName) {
        var event = new Event(EventName);
        window.dispatchEvent(event);
    };
    init.prototype.loadComponents = function () {
        this.dispatchWindowEvents(enums_1.WindowEvents.INIT_START);
        this.initCore();
    };
    init.prototype.loadExternalDependencies = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _i, item;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = [];
                        for (_b in enums_1.ExternalScripts)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        item = _a[_i];
                        return [4 /*yield*/, this.loadAsyncScript(enums_1.ExternalScripts[item], false)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    init.prototype.loadArtifiDependencies = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _i, i, url, prefix;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = [];
                        for (_b in enums_1.ArtifiScripts)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        i = _a[_i];
                        url = enums_1.CDNServer[this.props.environment] + enums_1.ArtifiScripts[i];
                        prefix = '.js';
                        if (i === 'artifiCore') {
                            prefix = (this.props.environment == enums_1.Environment.development ? '.js' : '.min.js');
                        }
                        url += prefix;
                        return [4 /*yield*/, this.loadScript(url, i === 'artifiCore')];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    init.prototype.loadDependencies = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                promise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: 
                            /* External Scripts */
                            return [4 /*yield*/, this.loadExternalDependencies()];
                            case 1:
                                /* External Scripts */
                                _a.sent();
                                /* Artifi Scripts */
                                return [4 /*yield*/, this.loadArtifiDependencies()];
                            case 2:
                                /* Artifi Scripts */
                                _a.sent();
                                resolve();
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/, promise];
            });
        });
    };
    init.prototype.loadAsyncScript = function (url, buildTimestamp) {
        if (buildTimestamp === void 0) { buildTimestamp = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            // resolve if already loaded
                            if (document.querySelector('script[src="' + url + '"]')) {
                                resolve({
                                    script: url,
                                    loaded: true,
                                    status: "Already Loaded",
                                });
                            }
                            else {
                                // load script
                                var script = document.createElement("script");
                                script.type = "text/javascript";
                                // script.async = true;
                                if (buildTimestamp) {
                                    script.src = url + '?' + (process.env.BUILD_TIMESTAMP || '');
                                }
                                else {
                                    script.src = url;
                                }
                                script.onload = function () {
                                    resolve({ script: url, loaded: true, status: "Loaded" });
                                };
                                script.onerror = function (error) {
                                    return resolve({ script: url, loaded: false, status: "Loaded" });
                                };
                                document.getElementsByTagName("head")[0].appendChild(script);
                            }
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    init.prototype.loadScript = function (url, buildTimestamp) {
        if (buildTimestamp === void 0) { buildTimestamp = true; }
        return new Promise(function (resolve, reject) {
            // resolve if already loaded
            if (document.querySelector('script[src="' + url + '"]')) {
                resolve({
                    script: url,
                    loaded: true,
                    status: "Already Loaded",
                });
            }
            else {
                // load script
                var script = document.createElement("script");
                script.type = "text/javascript";
                if (buildTimestamp) {
                    script.src = url + '?' + (process.env.BUILD_TIMESTAMP || '');
                }
                else {
                    script.src = url;
                }
                script.onload = function () {
                    resolve({ script: url, loaded: true, status: "Loaded" });
                };
                script.onerror = function (error) {
                    return resolve({ script: url, loaded: false, status: "Loaded" });
                };
                document.getElementsByTagName("head")[0].appendChild(script);
            }
        });
    };
    init.prototype.initCore = function () {
        var data = __assign(__assign({ sku: this.props.sku, websiteId: this.props.websiteId, userId: this.props.userId, isGuest: this.props.isGuest, webApiClientKey: this.props.webApiClientKey, productCode: this.props.productCode, divisionId: this.props.divisionId, productId: this.props.productId, familyId: this.props.familyId, companyId: this.props.companyId }, (this.props.customizedProductId ? { customizedProductId: this.props.customizedProductId } : {})), (this.props.environment ? { environment: this.props.environment } : {}));
        this.dispatch(window._Artifi.AppActions.INIT_APP_MODEL, data);
        this.subscribeStore();
    };
    init.prototype.subscribeStore = function () {
        var _this = this;
        window._Artifi.Store.subscribe(function () {
            var state = window._Artifi.Store.getState();
            var EditorAction = window._Artifi.EditorAction;
            var lastAction = state.lastAction;
            switch (lastAction.type) {
                case EditorAction.VIEW_LOADED: {
                    _this.loadOtherComponents(state);
                    break;
                }
            }
        });
    };
    init.prototype.getComponentContainer = function (component) {
        var container = enums_1.DefaultComponentContainers[component];
        if (this.props[component]) {
            var customConfig = this.props[component];
            if (typeof customConfig == "string") {
                container = customConfig;
            }
            else if (typeof customConfig == "object" && customConfig.id) {
                container = customConfig.id;
            }
        }
        return document.querySelector("#" + container);
    };
    init.prototype.getComponentCDNLink = function (component) {
        var url = enums_1.CDNServer[this.props.environment] + enums_1.ArtifiComponents[component];
        url = url + (this.props.environment == enums_1.Environment.development ? '.js' : '.min.js');
        if (this.props[component]) {
            var customConfig = this.props[component];
            if (typeof customConfig == "object" && customConfig.url) {
                url = customConfig.url;
            }
        }
        return url;
    };
    init.prototype.loadProductViews = function () {
        var _this = this;
        var productViewContainer = this.getComponentContainer(enums_1.Components.productview);
        if (productViewContainer) {
            this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.productview)).then(function () {
                var productViewConfig = _this.props[enums_1.Components.productview];
                _this.renderComponent(window.ArtifiProductViews.ProductViewsContainer, productViewContainer, (productViewConfig && productViewConfig.props) || {});
            });
        }
    };
    init.prototype.loadPrice = function () {
        var _this = this;
        var priceContainer = this.getComponentContainer(enums_1.Components.price);
        if (priceContainer) {
            this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.price)).then(function () {
                var priceConfig = _this.props[enums_1.Components.price];
                priceConfig = priceConfig && priceConfig.props ? priceConfig.props : {};
                _this.renderComponent(window.ArtifiPrice.PriceContainer, priceContainer, (priceConfig) || {});
            });
        }
    };
    init.prototype.loadProductOptions = function () {
        var _this = this;
        var productOptionsContainer = this.getComponentContainer(enums_1.Components.productOptions);
        if (productOptionsContainer) {
            this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.productOptions)).then(function () {
                var clientProps = _this.props[enums_1.Components.productOptions];
                var props = clientProps && clientProps.props ? clientProps.props : {};
                _this.renderComponent(window.ArtifiProductOptions.ProductOptionsContainer, productOptionsContainer, props);
            });
        }
    };
    init.prototype.loadZoom = function () {
        var _this = this;
        var zoomContainer = this.getComponentContainer(enums_1.Components.zoom);
        if (zoomContainer) {
            this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.zoom)).then(function () {
                var clientProps = _this.props[enums_1.Components.zoom];
                var props = clientProps && clientProps.props ? clientProps.props : {};
                _this.renderComponent(window.ArtifiZoom.ZoomContainer, zoomContainer, props);
            });
        }
    };
    init.prototype.loadAddToCart = function () {
        var _this = this;
        var addToCartContainer = this.getComponentContainer(enums_1.Components.addToCart);
        if (addToCartContainer) {
            this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.addToCart)).then(function () {
                var clientProps = _this.props[enums_1.Components.addToCart];
                var props = clientProps && clientProps.props ? clientProps.props : {};
                _this.renderComponent(window.ArtifiAddToCart.AddToCartContainer, addToCartContainer, props);
            });
        }
    };
    init.prototype.isWidgetAllowed = function (widgetsData, views, currentWidget) {
        if (widgetsData[currentWidget].allow) {
            return true;
        }
        var widgetExistsInView = false;
        for (var currentView in views) {
            if (views[currentView][currentWidget] && Object.keys(views[currentView][currentWidget]).length > 0) {
                widgetExistsInView = true;
                break;
            }
        }
        return widgetExistsInView;
    };
    init.prototype.loadWidgetComponent = function (widgetsData, views) {
        for (var widget in widgetsData) {
            if (this.isWidgetAllowed(widgetsData, views, widget)) {
                switch (widget) {
                    case enums_1.Components.text:
                        this.renderTextComponent();
                        break;
                    case enums_1.Components.image:
                        this.renderImageComponent();
                        break;
                }
            }
        }
    };
    init.prototype.loadOtherComponents = function (state) {
        var _this = this;
        /* load renderer component */
        var renderer = this.getRenderer(state);
        var sku = state.appData.sku;
        var viewData = state.editorData.views[sku];
        var selectedViewId = viewData.selectedView.viewId;
        this.displayRenderer(renderer);
        /* render hybrid or custom component */
        if (typeof this.props[enums_1.Components.custom] != 'undefined') {
            var customContainer_1 = this.getComponentContainer(enums_1.Components.custom);
            if (customContainer_1) {
                this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.custom)).then(function () {
                    if (_this.props[enums_1.Components.custom]['libName']) {
                        // TODO: dynamically add component name
                        _this.renderComponent(window._artifiComponent.MaxwellComponent, customContainer_1);
                    }
                });
            }
        }
        /* Text graphics panel */
        var widgetsData = state.editorData.views[sku].viewList[selectedViewId]
            .allowedObjects;
        this.loadProductViews();
        this.loadPrice();
        this.loadProductOptions();
        this.loadWidgetComponent(widgetsData, state.editorData.views[sku].viewList);
        this.loadZoom();
        this.loadAddToCart();
        this.dispatchWindowEvents(enums_1.WindowEvents.INIT_DONE);
        if (this.props.onComponentsLoaded) {
            this.props.onComponentsLoaded();
        }
    };
    init.prototype.getRenderer = function (state) {
        var renderer;
        if (this.props.renderer) {
            renderer = this.props.renderer;
        }
        else {
            renderer = state.editorData.renderer
                ? state.editorData.renderer
                : enums_1.Components.fabric;
        }
        return renderer;
    };
    init.prototype.displayRenderer = function (renderer) {
        var _this = this;
        var rendererContainer = this.getComponentContainer(renderer);
        if (rendererContainer) {
            switch (renderer) {
                case enums_1.Components.fabric:
                    this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.fabric)).then(function () {
                        _this.renderComponent(window.ArtifiFabric.FabricContainer, rendererContainer);
                    });
                    break;
                case enums_1.Components.irs:
                    this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.irs)).then(function () {
                        _this.renderComponent(window.ArtifiIrs.IrsContainer, rendererContainer);
                    });
                    break;
            }
        }
    };
    init.prototype.renderTextComponent = function () {
        var _this = this;
        var textContainer = this.getComponentContainer(enums_1.Components.text);
        if (textContainer) {
            this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.text)).then(function () {
                _this.renderComponent(window.ArtifiTextbox.TextContainer, textContainer);
            });
        }
    };
    init.prototype.renderImageComponent = function () {
        var _this = this;
        var imageContainer = this.getComponentContainer(enums_1.Components.image);
        if (imageContainer) {
            this.loadAsyncScript(this.getComponentCDNLink(enums_1.Components.image)).then(function () {
                _this.renderComponent(window.ArtifiGraphics
                    .GraphicsContainer, imageContainer);
            });
        }
    };
    init.prototype.dispatch = function (type, payload) {
        window._Artifi.Store.dispatch({
            type: type,
            payload: payload,
        });
    };
    init.prototype.renderComponent = function (element, target, props) {
        window.ReactDOM.render(window.React.createElement(element, props || {}), target);
    };
    return init;
}());
exports.init = init;
